import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * ログインユーザーID管理サービス
 * @export
 * @class LoginUserIdService
 */
@Injectable({
  providedIn: 'root'
})
export class LoginUserIdService {

  /** ログインユーザーID */
  private _loginUserId$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor() { }

  /**
   * ログインユーザーIDを取得
   *
   * @return {*}  {string}
   * @memberof LoginUserIdService
   */
  get loginUserId(): Observable<string> {
    return this._loginUserId$.asObservable();
  }

  /**
   * ログインユーザーIDを更新
   *
   * @return {*}  {string}
   * @memberof LoginUserIdService
   */
  set loginUserId(data: string) {
    this._loginUserId$.next(data);
  }

}
